import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useApplyNowLink = () => {
  const [applyNowUrl, setApplyNowUrl] = useState('');
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const lofId = sessionStorage.getItem('lofID');
      if (lofId) {
        setApplyNowUrl(`https://www.swmc.com/ApplyNow/?lof=${lofId}`);
      } else {
        setApplyNowUrl('https://www.swmc.com/ApplyNow/?c=lowrates');
      }
    }, 50); // slight delay to ensure sessionStorage has updated

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return applyNowUrl;
};
